import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SubscriptionWall } from './SubscriptionWall';

export const ProtectedRoute = ({ children, adminOnly = false, requireSubscription = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#212A31] flex items-center justify-center">
        <div className="text-[var(--brand)] text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && user.role !== 'admin' && user.role !== 'manager') {
    return <Navigate to="/dashboard" />;
  }

  // Show subscription wall for restricted users on protected features
  if (requireSubscription && user.role !== 'admin' && user.role !== 'manager') {
    const sub = user.subscription || {};
    const trial = user.trial || {};
    const isRestricted = sub.is_restricted === true || (!sub.has_subscription && !trial.trial_active);
    if (isRestricted) {
      return <SubscriptionWall />;
    }
  }

  return children;
};
